"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAndTriggerWhatsNewDialog = void 0;
const checkAndTriggerWhatsNewDialog = ({ isUserPrefLoading, userPreferences, setUserPreference, currentVersion, hasWhatsNewJSON, showReleaseNotes, dispatchShowReleaseNotesDialog, dispatchShowWhatsNewDialog, }) => {
    if (isUserPrefLoading === false && (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.whatsNewViewed) !== currentVersion) {
        if (showReleaseNotes && hasWhatsNewJSON === false) {
            dispatchShowReleaseNotesDialog();
        }
        else {
            dispatchShowWhatsNewDialog();
        }
        setUserPreference({ whatsNewViewed: currentVersion });
    }
};
exports.checkAndTriggerWhatsNewDialog = checkAndTriggerWhatsNewDialog;
